/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useEffect } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { BaseStepCompProps } from '../types';
import { useAppSelector } from '../../../reducers';
import { isStaff, isUserActivated } from '../../../selectors/user';

export const ReferralInfo = (props: BaseStepCompProps) => {
  const { updateForm, handleNext, formData } = props;

  const isActivated = useAppSelector(isUserActivated);
  const isUserStaff = useAppSelector(isStaff);

  const canGoNext = formData.referralCode;

  useEffect(() => {
    if (isActivated && !isUserStaff) {
      // Skip this step if already activated,
      // except if Staff to allow creating companies
      // without needing to create a new user
      handleNext();
    }
  }, [isActivated, isUserStaff, handleNext]);

  return (
    <div className='d-lg-flex justify-content-between onboarding-form'>
      <aside className='title-container'>
        <div className='h4 text-strong mb-3'>Referral info</div>
      </aside>
      <section className='form-container'>
        <Form>
          <div className='row'>
            <div className='col'>
              <FormGroup>
                <Label for='referralCode'>Enter your referral code</Label>
                <Input
                  placeholder='Enter code'
                  id='referralCode'
                  name='referralCode'
                  type='text'
                  onChange={(e) => updateForm('referralCode', e.target.value)}
                  defaultValue={formData.referralCode}
                />
                <p className='mt-1'>If you were given one</p>
              </FormGroup>
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col'>
              <FormGroup>
                <Label for='referenceCompany'>Who introduced you to this service?</Label>
                <Input
                  placeholder={'Enter name or company name here'}
                  id='referenceCompany'
                  name='referenceCompany'
                  type='text'
                  onChange={(e) => updateForm('referenceCompany', e.target.value)}
                  defaultValue={formData.referenceCompany}
                />
                <p className='mt-1'>Optional</p>
              </FormGroup>
            </div>
          </div>
        </Form>
        <div className='mt-5 d-flex'>
          <Button color='link-secondary' onClick={handleNext}>Skip this<i className='far fa-angle-right ml-2' /></Button>
          <Button className='ml-auto' color='primary' disabled={!canGoNext} onClick={handleNext}>Next<i className='far fa-angle-right ml-2' /></Button>
        </div>
      </section>
    </div>
  );
}
